import * as catalogos from './catalogos/es';
export const locale = {
  lang: 'es',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB':'Guardando cambios..',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG':'Preguntas',
      'TITULO_TAB_TRAD':'Traducción',
      'TITULO_TAB_PREV':'Previsualización',
      'TAB_PREGUNTAS':{
        'CLA':'Clave:',
        'BTN_CONFIG_PLA':'Configuración de la plantilla',
        'SLI_VER_US_EMPRE':'Ver como usuario empresa',
        'ETI_INSTNES':'Puede cargar una lista de preguntas contenidas en una plantilla, siguiendo estos pasos:',
        'ETI_INST1':'Descargue la plantilla',
        'ETI_INST2':'Llene la plantilla con las preguntas según el formato',
        'ETI_INST3':'Cargue la plantilla con las preguntas',
        'ETI_INST_NOT':'Nota: puede cargar una lista de preguntas de manera general o dentro de cada sección disponible',
        'ETI_SECCI_NOT_GRU':'Esta sección no tiene ningún grupo',
        'INST_AGRE_GRUP':'Agregue un grupo de preguntas con el siguiente botón',
        'BTN_AGRE_GRUP':'Agregar un grupo',
        'INST2_AGRE_GRUP':'Posteriormente podrá agregar preguntas a este grupo',
        'ETI_DETEC_CAMB_PLAN':'Se detectaron cambios en la plantilla original',
        'BTN_GUAR_CAMB':'Guardar cambios',
        'BTN_GUAR_CAMB_NEW_PLAN':'Guardar como nueva plantilla',
        'MAT_DESC_PLAN':'Descargar plantilla',
        'ETI_LIS_GRUP':'Lista de grupos',
        'MAT_CHIP_PRE_EXTR_SI':'Preguntas extra disponibles: ',
        'MAT_CHIP_PRE_EXTR_NO':'Ya no puede agregar preguntas extra',
        'MAT_CHIP_PRE_EXTR_ILIM':'Preguntas extra ilimitadas',
        'ETI_INST_COLO_CUR':'Coloque el cursor sobre algún grupo para ver las acciones disponibles',
        'MAT_EDIT_NOMB_SECC':'Editar el nombre del grupo',
        'MAT_DELET_SECC':'Eliminar este grupo',
        'MAT_AGRE_SECC_ARRI':'Agregar un grupo arriba',
        'ETI_SECC_SIN_PREG':'Este grupo no cuenta con preguntas',
        'ETI_SECC_INST_COLO_CUR':'Coloque el cursor sobre alguna pregunta para ver las acciones disponibles',
        'ETI_PREG_OPCIO_EDITA':'Pregunta opcional editable',
        'ETI_PREG_OPCIO_NO_EDITA':'Pregunta opcional no editable',
        'ETI_PREG_OPCIO_OBLI_EDITA':'Pregunta obligatoria editable',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA':'Pregunta obligatoria no editable',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'Pregunta obligatoria respuesta',
        'MAT_FALT_OPC_RESP':'Faltan las opciones de respuesta',
        'ETI_FALT_OPC_RESP':'Pregunta faltante de opciones de respuesta',
        'MAT_NO_GUAR_CATA':'Aún no guardada en el catálogo',
        'ETI_PREG_NO_GUAR_CATA':'Pregunta aún no guardada en el catálogo',
        'MAT_CHIP_TIP':'tipo',
        'MAT_TOOL_DETA_PREG':'Detalle de la pregunta',
        'BTN_EDIT_PREG':'Ver detalles',
        'MAT_TOOL_MOVE_PREG':'Mover esta pregunta',
        'BTN_EDIT_ES_PREG':'Editar esta pregunta',
        'BTN_DELE_ES_PREG':'Eliminar esta pregunta',
        'MAT_TOOL_AGRE_PREG_ARRI':'Agregar pregunta arriba',
        'MAT_TOOL_AGRE_PREG_ABAJ':'Agregar pregunta abajo',
        'MAT_LABE_SELE_VERSI_PREG':'Seleccione una versión de la pregunta',
        'MAT_LABE_TEX_PREG':'Texto de la pregunta',
        'MAT_LABE_TEX_PREG_KEY':'Clave de la pregunta especial',
        'ETI_CUE_SIG_ACC_PREG':'Cuenta con las siguientes acciones para esta pregunta',
        'MAT_CARD_MAES':'Catálogo maestro',
        'ETI_DETEC_CAMB_TEX_PREG':'Se detectaron cambios en el texto de la pregunta',
        'MAT_TOOL_AUN_NO_GUA_CATA':'Aún no esta guardada en el catálogo',
        'ETI_ESTA_PREG_NO_GUAR_CATA':'Esta pregunta no está guardada en el catálogo',
        'ETI_GUAR_PREG':'Guardar pregunta',
        'ETI_GUAR_CAMB':'Guardar cambios',
        'MAT_SLIDE_PREG_EDIT':'Pregunta editable',
        'MAT_SLIDE_PREG_DELET':'Pregunta eliminable',
        'MAT_SLIDE_PREG_REQUI':'Respuesta obligatoria',
        'ETI_AGRE_PREG':'Agregar una pregunta',
        'ETI_GRUP_PREG':'Grupo de preguntas',
        'ETI_SECC_ESP':'Sección especial',
        'ETI_KEY_NO_EMPL':'Clave de sección especial no empleada',
        'ETI_FALT_KEY_SEC_ESP':'*Falta clave de sección especial',
        'ETI_CLA_GRU_LIS':'Clave:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG':'Mover pregunta',
          'ETI_INTS_SELEC_SECC_MOVE':'Seleccione el grupo  a donde desee mover la pregunta',
          'ETI_NOT_PREG_MOVE1':'NOTA:',
          'ETI_NOT_PREG_MOVE2':'La pregunta se moverá al final del grupo seleccionado',
          'BTN_CANCELAR':'Cancelar',
          'ETI_CONFI_PLAN':'Configuración de la plantilla',
          'ETI_DATOS_PLAN':'Datos de la plantilla:',
          'ETI_NOMB':'Nombre:',
          'ETI_SECC':'Grupos:',
          'ETI_PREG':'Preguntas:',
          'ETI_NOT_CONF_CONT_SECC':'NOTA: La configuración de estos controles se aplica a todos los grupos y preguntas de la plantilla en el modo de visualización como usuario tipo empresa',
          'ETI_PERMI_SECC':'Permisos de grupos',
          'ETI_AGRE_SECC_NEW':'Agregar grupos nuevos',
          'ETI_MOVE_SECC':'Mover grupos',
          'ETI_EDIT_TITU':'Editar título',
          'ETI_DELET_SECC':'Borrar grupos',
          'ETI_NOMB_OBL_GRUP_NEW':'Nombres obligatorios en grupos nuevos',
          'ETI_ENABLE_SEC_ESP': 'Habilitar secciones / preguntas especiales',
          'ETI_PERMIS_PREG':'Permisos de preguntas para cada grupo: ',
          'ETI_AGRE_PREG_NEW':'Agregar preguntas nuevas',
          'ETI_AGRE_PREG_CATAL':'Agregar preguntas de catálogo',
          'ETI_MOVE_PREGS':'Mover preguntas',
          'ETI_EDIT_PREG':'Editar preguntas',
          'ETI_DELET_PREG':'Eliminar preguntas',
          'ETI_REQUIRED':'Respuestas obligatorias',
          'ETI_PREG_NEW_MAX':'Preguntas nuevas máximas',
          'ETI_PREG_NEW_MAX_4ALL':'Número de prácticas 4All',
          'ETI_MAX_PREG_NEW':'Máximo de preguntas nuevas',
          'ETI_ENABLE_AUDIOS': 'Habilitar pistas de audio',
          'ETI_DEMOGRAF':'Demográficos',
          'ETI_ABIER':'Abiertas',
          'ETI_PRAC4ALL':'Práctias 4All',
          'ETI_ADICIO':'Adicionales',
          'BTN_SAL':'Salir',

          'ETI_INST_AGRE_PREG_CAT':'Agregar pregunta de catálogo',
          'ETI_BUSC_SELECC_PREG_PLAN':'En esta pantalla puede buscar y seleccionar preguntas para agregar a la plantilla',
          'ETI_VER_LIS_PREG_SELEC_3_PEST':'Podrá ver la lista de preguntas seleccionadas en la tercer pestaña de esta ventana',
          'TITULO_TAB_LIS_PREG':'Lista de preguntas',
          'TITULO_TAB_BUSC_PREG':'Buscar pregunta',
          'TITULO_TAB_PREG_SELEC':'Preguntas seleccionadas',
          'PASO_1':'Paso 1',
          'PASO_2':'Paso 2',
          'ETI_SELEC_PREG_LIS_CAT':'Seleccione la pregunta de la lista del catálogo',
          'ETI_SELEC_PREG':'Seleccione una pregunta',
          'ETI_YA_SELEC_NUM_MAX_PREG':'Ya ha seleccionado el número máximo de preguntas extra permitidas en la plantilla',
          'ETI_PREG_MS_UNA_VERS':'Esta pregunta cuenta con más de una versión, seleccione la que desea visualizar',
          'ETI_SELEC_VERS':'Seleccione una versión',
          'ETI_PREG_SELECCIONDA':'Pregunta seleccionada:',
          'ETI_AGRE_PREG':'Agregar pregunta',
          'ETI_OK_AGRE_PREG_LIST':'<b>Se agregó la pregunta a la lista de preguntas</b>, puede elegir y agregar más preguntas para agregar a la plantilla.',
          'ETI_OK_AGRE_PREG_LIST2':'También puede ver la lista de preguntas seleccionadas en la tercer pestaña de esta ventana',
          'ETI_ESCR_TEXT_BUSC':'Escriba el texto de la pregunta que desea buscar',
          'ETI_BUSC_PREG_COINC':'Buscando preguntas coincidentes',
          'ETI_NO_ENCO_PREG':'No se encontraron preguntas con el texto introducido, intente con un texto diferente',
          'ETI_RESUL_BUSC':'Resultados de la búsqueda',
          'BTN_ELEG':'Elegir',
          'ETI_REGRE_RESUL':'Regresar a los resultados',
          'ETI_PREG_SELECC_MOMEN':'Lista de preguntas seleccionadas hasta el momento',
          'MAT_TOOL_ELEG_VERSI':'Elegir otra versión',
          'MAT_TOOL_ELI_VERSI':'Eliminar  versión',
          'BTN_REGRES':'Regresar',
          'BTN_ELIG_VERSI':'Elegir versión',
          'MAT_TOOL_QUITA_LIS':'Quitar de la lista',

          'BY_TEXT': 'Por texto',
          'BY_KEYWORDS': 'Por palabras clave',
          'QUESTION_TEXT': 'Texto de la pregunta',
          'QUESTION_KEYWORDS': 'Palabras clave',
          'QUESTION_HINT': 'Las palabras claves deben comenzar con el caracter <b>#</b> e ir separadas por comas'
        },
        'DETALLE':{
          'ETI_DETALL_PREG':'Detalle de la pregunta',
          'ETI_LAB_TEX_PREG':'Texto de la pregunta',
          'PLACE_HOL_TEX_PREG':'Texto de la pregunta',
          'MAT_TOOL_EDIT_PREG':'Editar esta pregunta',
          'MAT_CARD_OPC_RESP':'Opciones de respuesta',
          'MAT_TOOL_EDIT_RESP':'Editar esta respuesta',
          'MAT_TOOL_DELET_RESP':'Eliminar esta respuesta',
          'ETI_AGRE_OPCI_RESP':'Agregar una opción de respuesta',
          'ETI_SELEC_VERSI_PREG':'Seleccione una versión de la pregunta',
          'ETI_CUENT_SIG_ACC_PREG':'Cuenta con las siguientes acciones para esta pregunta',
          'ETI_DETEC_CAMB_TEXMAES':'Catálogo maestro',
          'ETI_CATA_MAES':'Catálogo maestro',
          'ETI_DETEC_CAMB_TEX_PREG':'Se detectaron cambios en el texto de la pregunta',
          'ETI_DETEC_CAMB_TEX_RESP':'Se detectaron cambios en las opciones de respuesta',
          'ETI_PREG_NO_GUAR_CATA':'Esta pregunta no está guardada en el catálogo',
          'ETI_GUAR_PREG':'Guardar pregunta',
          'ETI_GUAR_CAMB':'Guardar cambios',
          'ETI_BORR_PREGUN':'Borrar pregunta',
          'ETI_DELET_PREG':'Eliminar pregunta',
          'MAT_CARD_PLAN':'Plantilla',
          'MAT_SLIDE_PREG_EDIT':'Pregunta editable',
          'MAT_SLIDE_PREG_DELET':'Pregunta eliminable',
          'MAT_SLIDE_PREG_REQUI':'Respuesta obligatoria',
          'BTN_REGRES':'Regresar',
          'ETI_NEW_PREG':'Nueva pregunta',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE':'Escriba el texto y seleccione el tipo de respuesta para la nueva pregunta',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP':'Escriba el texto y agregue opciones de respuesta para la nueva pregunta',
          'ETI_TIP_PREG':'Tipo de pregunta',
          'ETI_TIP_RESP':'Tipo de respuesta',
          'ETI_TIP_FORM':'Formato de pregunta',
          'ETI_PREG_ESP_FLD': 'Clave de pregunta especial',
          'ETI_PREG_ESP_HNT': 'Ingrese la clave para la pregunta especial',
          'BTN_CANCELAR':'Cancelar',
          'BTN_CONTINU':'Continuar',
          'ETI_NEW_PRAC_4ALL':'Nueva práctica 4All',
          'ETI_INST_NOMBRE_DESC_4ALL':'Escriba el nombre y la descripción para la nueva práctica 4All',
          'ETI_LABE_NOMBRE':'Nombre de la práctica',
          'ETI_LABE_DESC':'Descripción de la práctica',
          'ETI_CLAVE_DEMOGR':'Escriba una o más palabras clave que identifiquen a la pregunta, comenzando con el caracter',
          'ETI_CLAVE_DEMOGR1':'y separadas por comas',
          'ETI_CLAVE_DEMOGR2':'NOTA: Las palabras clave sólo se almacenarán si guarda esta pregunta al catálogo al cerrar esta ventana',
          'ETI_PALA_CLAVE_DEMOGR':'Palabras clave',
          'ETI_SELE_TIPO_DEMOGR':'Seleccione el tipo de demográfico al que corresponde la nueva pregunta',

          'MAT_TOOL_CONFIG_RESP':'Configurar esta respuesta',
          'MAT_SLIDE_RESP_EDIT':'Respuesta editable',
          'MAT_SLIDE_RESP_DELET':'Respuesta eliminable',
          'MAT_SLIDE_RESP_TIPO_OTRO':'Tipo "Otro"',
          'MAT_TOOL_NEWVERS_PREG':'Guardar como nueva versión',
          'NOTA_PREG_MOD': 'NOTA: El texto de esta pregunta ha sido modificado, puede guardarlo como nueva versión si lo desea',
          'RESPUESTA_TIPO_OTRO':' - respuesta tipo "Otro"',

          'TIPO_DEMOGRAFICO':'Tipo de demográfico',
          'SIN_TIPO_DEMOGRAFICO':'No se seleccionó el tipo de demográfico para esta pregunta'

        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP':'Nueva plantilla',
          'TEXT_MOD_GUA_CAM_TEMP':'Escriba el nombre para la nueva plantilla',
          'BTN_CAN_MOD_GUA_CAM_TEMP':'Cancelar',
          'BTN_AGRE_MOD_GUA_CAM_TEMP':'Agregar',
          'RETUR_MOD_GUA_CAM_TEMP':'No ha introducido un texto para el nombre',
          'SUCC_TEXT_MOD_GUA_PLAN':'Se guardó la nueva plantilla correctamente',
          'TITU_MOD_GUA_CAM_TEMP2':'¿Desea guardar los cambios realizados a la plantilla original?\n\nATENCIÓN: La próxima vez que un producto sea asignado con esta plantilla, se incluirán todos los cambios realizados hasta ahora',
          'BTN_CONTI_MOD_GUA_CAM_TEMP':'Continuar',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG':'Se guardaron los cambios a la plantilla original correctamente',
          'MENS_1':'¿Qué tipo de pregunta desea agregar a la sección?',
          'MENS_2':'Tiene dos opciones',
          'BTN_NEW':'Nueva',
          'BTN_D_CATA':'De catálogo',
          'TITU_MOD_CARG_LIS_COLAB_P1':'Este archivo continene ',
          'TITU_MOD_CARG_LIS_COLAB_P2':'secciones y un total de',
          'TITU_MOD_CARG_LIS_COLAB_P3':'preguntas.\n\nATENCIÓN: Si continúa con la carga de este archivo, las preguntas y grupos que tiene actualmente serán reemplazados.\n\n ¿Qué desea hacer con estas preguntas?',
          'TITU_TEX_MOD_CARG_LIS_COLAB':'Tiene dos opciones',
          'BTN_AGRE_PREGU':'Agregar las preguntas',
          'BTN_CANC_PREGU':'Descartar las preguntas',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB':'Se agregaron las preguntas correctamente',
          'TEXT_MOD_NOT_CARG_LIS_COLAB':'Se descartaron las preguntas',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB':'El archivo seleccionado cuenta con errores y no puede ser cargado. Revise nuevamente que todas las filas estén colocadas en el orden correcto y vuelva a intentarlo',
          'BTN_OK':'OK',
          'TITU_MOD_NEW_SECC':'Nueva sección',
          'TEXT_MOD_NEW_SECC':'Escriba el nombre para la nueva sección',
          'TEXT_SUCC_PREG_AGRE':'Se agregó la pregunta correctamente',
          'TITU_MOD_EDI_SECC':'Modificar nombre de la sección',
          'TEXT_SUCC_MODIF_SECC':'Se modificó el nombre de la sección correctamente',
          'TEXT_SUCC_MODIF_GRU':'Se modificó el nombre del grupo',
          'TITU_MOD_DELE_SECC1':'¿Está seguro de borrar esta sección?\n\nAtención: esta acción no puede ser revertida',
          'BTN_SI':'Sí',
          'BTN_NO':'No',
          'TITU_MOD_DELE_SECC2':'Esta sección contiene una o más preguntas, ¿qué desea hacer con estas preguntas?',
          'BTN_DELE_PRE':'Eliminar las preguntas',
          'BTN_CAN_TRAN':'Transferirlas a la sección anterior',
          'TEX_SUCC_DELE_PREG':'Se borró la sección correctamente',
          'TITU_AGRE_NEW_PREG':'Nueva pregunta',
          'TEXT_AGRE_NEW_PREG':'Escriba el texto para la nueva pregunta',
          'TITU_EDIT_PREG_MOD_PREG':'Modificar pregunta',
          'TITU_EDIT_PREG_MOD_PRACT':'Modificar práctica',
          'TITU_EDIT_PREG_MOD_DESCRI':'Modificar descripción',
          'TEXT_MOD_PREG_SUCC':'Se modificó la pregunta correctamente',
          'TITU_2_OPCIO':'Tiene dos opciones para guardar esta modificación',
          'BTN_CONF_ACT':'Actualizar pregunta',
          'BTN_CANC_NEW':'Como nueva pregunta',
          'BTN_CONF_ACT_VERSION':'Actualizar esta versión',
          'BTN_CANC_NEW_VERSION':'Como nueva versión',
          'TEX_CONFIR_MSG1':'Se modificó la pregunta correctamente',
          'TEX_CONFIR_MSG2':'Se modificó la práctica correctamente',
          'TEX_CONFIR_MSG3':'Se modificó la descripción correctamente',
          'TITU_DELE_PREG':'¿Está seguro de borrar esta pregunta?',
          'TEXT_SUCC_PREG':'Se borró la pregunta correctamente',
          'TITU_MOD_DELE_SECC_TEMPLA':'¿Está seguro de borrar esta sección?\n\nAtención: esta acción no puede ser revertida',
          'TITU_MOD_DELE_SECC_TEMPLA2':'Esta sección contiene una o más preguntas, ¿qué desea hacer con estas preguntas?',
          'TEX_SUCC_GUAR_PREG_':'Se guardó la pregunta correctamente',
          'TITU_MOD_DELE_PREG_MG':'¿Está seguro de borrar la pregunta del catálogo?\n\nATENCIÓN: Esta acción no podrá ser revertida y la pregunta dejará de estar disponible en las plantillas que la contengan actualmente',
          'TEX_CONFIR_MSG4_DELE':'Se eliminó la pregunta del catálogo correctamente',
          'TEX_GUAR_TRADU_SUCC':'Se guardó la traducción correctamente',
          'TEX_MOVE_PREG_SECC':'Se movió la pregunta a otra sección',
          'TEX_SUCC__PRAC_4ALL':'Se agregó la práctica correctamente',

          'MOD_MOD_AGRE_PREG':'Se agregó la pregunta a la lista correctamente',
          'MOD_MOD__MODIF_VERSI_PREG':'Se cambió la versión de la pregunta correctamente',
          'MOD_MOD__QUIT_PREG_LIST':'Se cambió la versión de la pregunta correctamente',
          'TITU_NUE_OPC_RESP':'Nueva opción de respuesta',
          'TEXT_NUE_OPC_RESP':'Escriba el texto para la nueva opción',
          'TEXT_NO_TEXT_PREG':'No ha introducido un texto para la pregunta',
          'TEXT_AGRE_OPC_RESP':'Se agregó la opción de respuesta correctamente',
          'MOD_EDIT_RESP':'Modificar opción de respuesta',
          'MOD_EDIT_MODIF_OPC_RESP':'Se modificó la opción de respuesta correctamente',
          'MOD_COMFIR_DELE_OPC_RESP':'¿Está seguro de borrar esta opción de respuesta?',
          'MOD_SUCC_DELE_OPC_RESP':'Se borró la opción de respuesta correctamente',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP':'No puede continuar sin haber agregado opciones de respuesta a la pregunta',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP':'No puede continuar sin haber escrito el texto de la pregunta antes',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP':'No puede continuar sin haber elegido el tipo de la pregunta',

          'MOD_AGRE_PREG_DONDE_GUARDAR': 'Antes de agregar la pregunta nueva, ¿desea que esta se guarde al catálogo? ¿o sólo desea tenerla en esta encuesta?',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': 'Al guardarla al catálogo podrá tenerla a disposición de otras encuestas si así lo desea',
          'BOT_DONDE_GUARDAR_1': 'Guardarla al catálogo',
          'BOT_DONDE_GUARDAR_2': 'Guardarla sólo a esta encuesta',
          'MOD_SIN_TAGS': 'Aún no ha ingresado por lo menos una palabra clave para la pregunta',
          'MOD_SIN_OPC_RESP': 'Aún no ha ingresado por lo menos dos opciones de respuesta para la pregunta',
          'MOD_SIN_TIPO_DEMO': 'Aún no ha seleccionado el tipo de demografico para esta pregunta',
          'MOD_SIN_CLA_ESPE': 'Aún no ha agregado la clave de la pregunta especial',
          'MOD_SIN_TIPO_RESP': 'No puede continuar sin haber seleccionado el tipo de respuesta a la pregunta',
          'MOD_RESP_DELOK': 'Se borró la opción de respuesta correctamente',
          'MOD_RESP_DELCATOK': 'Se eliminó la pregunta del catálogo correctamente',
          'MOD_RESP_ADDTAGOK': 'Se agregó la palabra clave a la pregunta correctamente',
          'MOD_RESP_ADDTAGERR': 'La palabra clave no comenzó con el caracter #',
          'MOD_RESP_DELTAGOK': 'Se removió la palabra clave de la pregunta correctamente',
          'MOD_SAVE_CAMBIOS_PREGCAT': 'Al guardar cambios a esta pregunta del catálogo, las modificaciones realizadas se guardarán como nuevas versiones de los textos de la pregunta y opciones de respuesta si aplica el caso.\n\n¿Desea continuar?',
          'MOD_SAVE_CAMB_PREGCAT': '¿En donde desea almacenar esta modificación al texto de la pregunta?',
          'BTN_MOD_SAVE_CAMB_PREGCAT': 'Sólo en esta encuesta',
          'BTN_MOD_ACTUA_PREGCAT': 'Actualizar la pregunta en el catálogo',


        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG':'Cargando',
        'TEXT_NO_ELEG_ADIC':'No eligió idiomas adicionales',
        'ERR_MSG_TRADU':'Traducción aún no completada',
        'TEX_IDIO_PRIN':'Idioma principal',
        'TEX_NAM_GRUP':'Nombre del grupo',
        'TEX_TRAD_NAM':'Ingrese la traducción del nombre',
        'TEX_NO_TRAD_TEXT':'¡No ha introducido el texto de traducción!',
        'TEX_TEX_PREG':'Texto de la pregunta',
        'TEX_TEX_RESP':'Texto de la respuesta',
        'TEX__TRA_PREG':'Ingrese la traducción de la pregunta',
        'TEX__TRA_RESP':'Ingrese la traducción de la respuesta',
        'GUAR_TRA_NAM':'Guardando traducción del nombre, espere por favor',
        'GUAR_TRA_PRE':'Guardando traducción de la pregunta, espere por favor',
        'GUAR_TRA_RES':'Guardando traducción de la opción de respuesta, espere por favor',
        'INGR_TEX_PRAC_4ALL':'Práctica',
        'INGR_TEX_TRADU_PRAC_4ALL':'Ingrese la traducción de la práctica',
        'INGR_TEX_DESCR_4ALL':'Descripción',
        'INGR_TEX_TRADU_DESCR_4ALL':'Ingrese la traducción de la descripción',
        'GUAR_TRADU_PRAC': 'Guardando traducción de la práctica, por favor espere...',
        'GUAR_TRADU_DESCR': 'Guardando traducción de la descripción, por favor espere...',
      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI':'Seleccione un idioma para mostrar las traducciones de las preguntas',
        'ETI_SIN_TRAD_PRE':'¡Falta ingresar el texto de traducción!',
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': 'Añadir una pista de audio',
          'CHANGE': 'Reemplazar pista de audio'
        },
        'SUBTITULO': 'Puede asociar una pista de audio a esta pregunta a través de una de las siguientes opciones',
        'BOTONES': {
          'RESTART': 'Volver al inicio',
          'NEXT': 'Siguiente',
          'BACK': 'Regresar',
          'ACEPTAR': 'Aceptar',
          'CANCELAR': 'Cancelar'
        },
        'OPCIONES': {
          'GOOGLE': 'Generar una narración automática',
          'RECORD': 'Grabar una nararación',
          'ARCHIVO': 'Cargar un archivo mp3',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': 'Puede editar el texto para generar la narración automática',
            'INPUT': 'Texto de la pregunta',
            'INPUT_TT': 'Escriba el texto de la pregunta',
            'NOTA': 'NOTA: Modificar este texto no modificará el texto de la pregunta en la encuesta'
          },
          'RECORD': {
            'TITULO': 'Haga clic en el botón Grabar para comenzar a grabar audio del micrófono',
            'NOTA': 'NOTA: Es posible que requiera otorgar permiso para utilizar el micrófono al navegador',
            'START': 'Comenzar grabación',
            'STOP': 'Grabando audio, haga clic en el botón para detener la grabación'
          },
          'ARCHIVO': {
            'INPUT': 'Haga clic aquí o arrastre el archivo de audio a esta zona para cargarlo',
            'NOTA': 'NOTA: Sólo se admite el formato MP3'
          },
          'PREVIEW': {
            'GENERANDO': 'El audio se está generando, espere un momento',
            'TITULO': 'A continuación puede escuchar el audio cargado',
            'NOTA_1': 'Si desea guardar esta pista de audio a la pregunta, haga clic en el botón Aceptar',
            'NOTA_2': 'Si desea cambiar el audio, haga clic en el botón Regresar',
            'NOTA_3': 'Si desea cambiar el tipo de audio cargado, haga clic en el botón Volver al inicio'
          }
        },
        'MODALES': {
          'DESCARTAR': '¿Está seguro de regresar al paso anterior?\n\nSe descartará la pista actual',
          'ARCHIVO_MAL': 'El archivo cargado no es una pista de audio',
          'GUARDANDO': 'Guardando pista de audio a la pregunta, espere un momento',
          'BORRAR': '¿Está seguro de borrar la pista de audio asociada a esta pregunta?',
          'CONFIRMAR_BORRAR': 'Para confirmar, ingrese el codigo en rojo en la caja de texto:\n\n',
          'BORRADO_OK': 'Se borró la pista de audio de la pregunta correctamente',
          'CODIGO_MAL': 'El codigo ingresado, no coincide con el indicado en rojo',
          'AGREGANDO_PREGUNTAS': 'Se están agregando las preguntas seleccionadas a la sección, espere un momento'
        },
        'PREVIOS': {
          'TITULO': 'Pista de audio asociada',
          'SIN_AUDIO': 'No hay una pista de audio asociada',
          'SIN_AUDIO_FORALL': 'Sin pista de audio',
          'ADD_AUDIO': 'Añadir una pista de audio',
          'CON_AUDIO': 'Esta pregunta tiene una pista de audio',
          'PLAY': 'Reproducir audio',
          'CHANGE': 'Reemplazar audio',
          'DELETE': 'Eliminar audio',
          'AUDIO_STATEMENT_1': 'Pista de audio del statement 1',
          'AUDIO_STATEMENT_2': 'Pista de audio del statement 2',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': 'Seccion especial',
        'SUBTITULO_1': 'Este grupo de preguntas puede establecerse como una sección especial, las preguntas de este grupo serán mostradas sólo a los colaboradores que tengan la misma clave',
        'SUBTITULO_2': 'NOTA: Es necesario que por lo menos un colaborador sea asociado a esta sección especial en el paso de carga de colaboradores',
        'TIPOS': {
          'NORMAL': 'Sección normal',
          'ESPECIAL': 'Sección especial'
        },
        'CAMPO': {
          'TITULO': 'Clave de la sección',
          'TOOLTIP': 'Escriba la clave de esta sección',
          'HINT': 'Sin espacios',
          'ACEPTAR': 'Aceptar'
        },
        'MODALES': {
          'CONFIRM_DISABLE': 'Si deshabilita las secciones especiales, los grupos de preguntas que actualmente están marcados como Secciones especiales serán convertidos en grupos de preguntas normales, este cambio aplicará en todas las secciones de preguntas. \n\n ¿Está seguro de continuar?',
          'DISABLE_OK': 'Todas las secciones especiales encontradas se convirtieron a grupos de preguntas normales',
          'SIN_CLAVE': 'Para guardar la sección especial es necesario que escriba una clave para la sección'
        }
      }
    },
  }
};
